import { createFileRoute, Link } from "@tanstack/react-router";
import { useSEO } from "../../hooks/useSEO";
import { IntegrationPage } from "../../components/integrations/IntegrationPage";
import { getIntegrationBySlug } from "../../data/integrations";

export const Route = createFileRoute("/integrations/$slug")({
  component: IntegrationSlugPage,
});

function IntegrationSlugPage() {
  const { slug } = Route.useParams();
  const integration = getIntegrationBySlug(slug);
  if (!integration) return <IntegrationNotFound />;
  return <IntegrationPage integration={integration} />;
}

function IntegrationNotFound() {
  useSEO({
    title: "Integration Not Found — ProvenLeap",
    description: "That integration page doesn't exist. Browse all ProvenLeap integrations.",
    path: "/integrations",
    robots: "noindex, nofollow",
  });
  return (
    <div className="flex min-h-screen items-center justify-center bg-white px-4">
      <div className="text-center">
        <h1 className="text-2xl font-semibold text-foreground">Integration not found</h1>
        <p className="mt-2 text-muted-foreground">That integration doesn't exist or has moved.</p>
        <Link to="/integrations" className="mt-4 inline-block text-brand hover:underline">
          ← All integrations
        </Link>
      </div>
    </div>
  );
}
